import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import PaymentHistoryTable from './PaymentHistoryTable'
import { withSnackbar } from 'notistack'

const styles = {
  flex: {
    flex: 1,
  },
  paymentDialog: {
    maxWidth: 600,
  },
  paperFullScreen: {
    backgroundColor: '#ffcc00',
  },
  paymentDialogHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paymentDialogTitle: {
    fontSize: '1.5em',
    marginBlockStart: '0.83em',
    marginBlockEnd: '0.83em',
    marginInlineStart: 0,
    marginInlineEnd: 0,
    fontFamily: 'Exo 2',
    textAlign: 'center',
  },
  btnLInk: {
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'right',
    color: 'rgb(0, 111, 255)',
    cursor: 'pointer',
    textDecoration: 'underline',
    border: 0,
    boxShadow: 'none',
    padding: 0,
    background: 'transparent',
    outline: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  tableWraper: {
    padding: 16,
  },
}

function Transition(props) {
  return (
    <Slide direction="right" {...props} timeout={{ enter: 200, exit: 300 }} />
  )
}

class PaymentHistory extends Component {
  state = {
    open: false,
    data: null,
  }

  getHistoryData = () => {
    let url = '/card/history'

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(({ payments }) => {
        this.setState({ data: payments }, () => {
          this.handleClickOpen()
        })
      })
      .catch(errors)
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        <button className={classes.btnLInk} onClick={this.getHistoryData}>
          История операций по карте
        </button>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          classes={{
            root: classes.paymentDialog,
            paperFullScreen: classes.paperFullScreen,
          }}
        >
          <header className={classes.paymentDialogHeader}>
            <IconButton
              color="inherit"
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </header>
          <article className={classes.paymentDialogWraper}>
            <header className={classes.paymentDialogTitle}>
              История операций по карте
            </header>
            <section className={classes.tableWraper}>
              {this.state.data && this.state.data.length ? (
                <PaymentHistoryTable data={this.state.data} />
              ) : (
                <p align="center">История операций отсутствует</p>
              )}
            </section>
          </article>
        </Dialog>
      </Fragment>
    )
  }
}

export default withStyles(styles)(withSnackbar(PaymentHistory))
